import BaseService from './base'
import axios from '@/plugins/axios'

export default class SettingService extends BaseService {
  static resource() {
    return 'api/v1/settings'
  }

  static async post_collection(payload = {}) {
    const { data } = await axios.post(`api/v1/settings_collection`, payload)
    return data.data
  }
}
